import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/OptionsMenu/options-menu';
import { DropdownItem } from '../Dropdown';
import CheckIcon from '@patternfly/react-icons/dist/js/icons/check-icon';
export var OptionsMenuItem = function OptionsMenuItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$isSelected = _a.isSelected,
      isSelected = _a$isSelected === void 0 ? false : _a$isSelected,
      _a$onSelect = _a.onSelect,
      onSelect = _a$onSelect === void 0 ? function () {
    return null;
  } : _a$onSelect,
      _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      isDisabled = _a.isDisabled,
      props = __rest(_a, ["children", "isSelected", "onSelect", "id", "isDisabled"]);

  return React.createElement(DropdownItem, Object.assign({
    id: id,
    component: "button",
    isDisabled: isDisabled,
    onClick: function onClick(event) {
      return onSelect(event);
    }
  }, isDisabled && {
    'aria-disabled': true
  }, props), children, isSelected && React.createElement("span", {
    className: css(styles.optionsMenuMenuItemIcon)
  }, React.createElement(CheckIcon, {
    "aria-hidden": isSelected
  })));
};